import { I18nService } from '@/core/services/i18nService';
import { AceZahlungAceZahlungEnumsAceZahlungStatuscode, AnfrageDisplayModel, GlobalEnumsAceErfolgtausstehend, GlobalEnumsAceMittelabruf, GlobalEnumsAceStatuszuwendungsbest, PaymentDisplayModel, PortalkonfigurationDisplayModel } from '@/api/model-index';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { AnfrageService } from '@/api/service-index';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NumberFormatOptions } from '@progress/kendo-angular-intl';
import { Constants } from '@/constants';
import { LoadingAnimationService } from '@/core/services/loading-animation.service';
import { MittelabrufDialogComponent } from '../../dialogs/mittelabruf-dialog/mittelabruf-dialog.component';
import { UntypedFormControl } from '@angular/forms';
import { PaymentService } from '@/core/services/payment.service';
import * as moment from 'moment';

@Component({
    selector: 'app-funding-table',
    templateUrl: './funding-table.component.html',
    styleUrls: ['./funding-table.component.scss']
})
export class FundingTableComponent {
    @Input()
    public type: GlobalEnumsAceMittelabruf;
    
    @Input()
    public anfrage: AnfrageDisplayModel;

    @Input()
    public portalkonfiguration: PortalkonfigurationDisplayModel;
    
    @Input()
    public foerdersummeOffen: number | null | undefined = 0;
    @Output()
    public foerdersummeOffenChange = new EventEmitter<number>();
    
    public mittelabrufDialog: DialogRef;
    public currencyFormatOptions: NumberFormatOptions = Constants.CURRENCY_FORMAT_OPTIONS;

    public get payments(): PaymentDisplayModel[]
    {
        return this.paymentService.payments;
    }

    public get isZahlung(): boolean
    {
        return this.type === GlobalEnumsAceMittelabruf.Zahlung;
    }

    public get isFoerderbetrag(): boolean
    {
        return this.type === GlobalEnumsAceMittelabruf.Forderbetrag;
    }

    constructor (
        protected anfrageService: AnfrageService,
        protected dialogService: DialogService,
        protected loadingAnimationService: LoadingAnimationService,
        protected paymentService: PaymentService,
        protected translateService: I18nService
        ) {}

    public zahlungNichtErfolgt(value: number): boolean {
        return value !== GlobalEnumsAceErfolgtausstehend.erfolgt;
    }

    public mittelAbrufbar(payment: PaymentDisplayModel): boolean {
        if (! payment.paymentDate)
            return true;
    
        let fristAb = this.portalkonfiguration.fristMittelabrufAb ? moment(payment.paymentDate).subtract(this.portalkonfiguration.fristMittelabrufAb, 'days') : moment(payment.paymentDate);
        let fristBis = this.portalkonfiguration.fristMittelabrufBis ? moment(payment.paymentDate).add(this.portalkonfiguration.fristMittelabrufBis, 'days') : moment(payment.paymentDate);
    
        return moment().isBetween(fristAb, fristBis);
    }

    // Zuwendungsbestätigung
    public zwb(value: number): string {
        if (! value)
            return "";
        return this.translateService.instant("Enum.mittelabrufZahlung." + GlobalEnumsAceStatuszuwendungsbest.getAsDataset().find(x => x.Value === value)?.Name ?? "undefinedText");
    }

    // Mittelabruf
    public mittelabruf(value: number): string {
        if (! value)
            return "-";
        return this.translateService.instant("Enum.mittelabruf." + GlobalEnumsAceErfolgtausstehend.getAsDataset().find(x => x.Value === value)?.Name ?? "undefinedText");
    }

    // Statusgrund
    public statusgrund(value: number): string {
        if (! value)
            return "-";
        return this.translateService.instant("Enum.mittelabrufStatusgrund." + AceZahlungAceZahlungEnumsAceZahlungStatuscode.getAsDataset().find(x => x.Value === value)?.Name ?? "undefinedText");
    }

    public async openNewFundsPaymentDialog(payment: PaymentDisplayModel | null) {
        let subscription = this.anfrageService.apiAnfrageAnfrageIdAttachmentGet({ anfrageId: this.anfrage.id, paymentId: payment?.id, loadContent: false, loadDocumentType: true  }).subscribe(response => {
            let documentsForm: UntypedFormControl = new UntypedFormControl();

            documentsForm.setValue(response);

            this.mittelabrufDialog = this.dialogService.open({
                content: MittelabrufDialogComponent,
                width: "50%",
                maxWidth: Constants.DIALOG.MAX_WIDTH,
                maxHeight: Constants.DIALOG.MAX_HEIGHT,
                title: this.translateService.instant("enquiry-card.callForFunds")
            });
    
            if (!this.anfrage.objektTyp)
                throw new Error("Anfrage has no objektTyp");
        
            let dialog: MittelabrufDialogComponent = this.mittelabrufDialog.content.instance;
    
            dialog.anfrageId = this.anfrage.id;
            dialog.payment = payment;
            dialog.dokumententyp = this.portalkonfiguration.mittelabrufDokumententyp;
            dialog.documentsForm = documentsForm;
            dialog.scope = this.anfrage.objektTyp;
            dialog.type = this.type;
            dialog.portalkonfiguration = this.portalkonfiguration;
            dialog.foerdersummeOffen = this.foerdersummeOffen;
            dialog.foerdersummeOffenChange = this.foerdersummeOffenChange;

            return this.mittelabrufDialog;
        });

        this.loadingAnimationService.showSpinnerUsingSubscription(subscription);
    }
}